import { ReportRequestForm } from './report';

export enum ResourceTypes {
    CONTACTS = 'contacts',
    SERVICES = 'services',
}

export class ResourceImportRequestForm {
    resourceIds!: string[];
    layerId!: number;
    resourceType!: ResourceTypes;
}

export interface InvoiceRequestForm {
    reportRequest: ReportRequestForm;
    hourlyRate?: number;
    markBilled?: boolean;
    contactId: string | number;
}

export interface InvoiceResponseForm {
    invoiceId: string;
    invoiceNumber: string;
    contactId: string;
    invoiceLink: string;
}

export interface ImportResults {
    imported: number;
    failed: number;
    tiles: Array<{
        tileId: number;
        contactId: string;
        name: string;
    }>;
    errors: Array<{
        contactId: string;
        error: string;
    }>;
}

export interface ImportResponse {
    message: string;
    results: ImportResults;
}

// TODO remove IntegrationEntity.ts and move all types here!
// Note: ImportResponse and InvoiceResponse are already moved...

export interface AutoImportRequestForm {
    layerId: number;
    resourceType: ResourceTypes;
    autoImport: boolean;
}

export type AutoImportResponseForm = AutoImportRequestForm;

// from api:
export class CheckActivities {
    activityIds!: number[];
    layerIndex!: number;
}

export class CheckUnitMappingRequestForm {
    tileIds?: number[];
    activities?: CheckActivities;
}

export interface CheckUnitMappingResponseForm {
    success: boolean;
    details: {
        failedTileIds: number[];
        missingUnits: string[];
    };
}
